__turbopack_context__.v({
  "accordion": "styles-module-scss-module__o1GZLW__accordion",
});
